var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      _c(
        "header",
        { attrs: { id: "content__header" } },
        [
          _c("div", { staticClass: "company-info" }, [
            _vm.resource.member
              ? _c("img", {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: _vm.resource.country.name,
                      expression: "resource.country.name",
                    },
                  ],
                  staticClass: "flag",
                  attrs: { src: _vm.resource.country.flag, alt: "test" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                _vm._s(
                  _vm.resource.companyName
                    ? _vm.resource.companyName
                    : _vm.resource.projectName
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.resource.can.edit
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: {
                    to: {
                      name: "madd-preview",
                      params: { madd_id: _vm.resource.id },
                    },
                  },
                },
                [_vm._v("Edit\n\t\t\t")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "company-info" }, [
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.createdAt
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Completed Date"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "calendar" } }),
                    _vm._v(" " + _vm._s(_vm.resource.completedAt)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.location
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Location of Activities"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "location" } }),
                    _vm._v(" " + _vm._s(_vm.resource.location)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.dealType
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Deal Type")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "deal" } }),
                    _vm._v(" " + _vm._s(_vm.resource.dealType)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.counterpartCompany
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Counterpart Company"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "company" } }),
                    _vm._v(" " + _vm._s(_vm.resource.counterpartCompany)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.transactionCurrency
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Currency")]),
                _vm._v(" "),
                _c(
                  "strong",
                  [
                    _c("SvgIcon", { attrs: { icon: "money" } }),
                    _vm._v(" " + _vm._s(_vm.resource.transactionCurrency)),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.transactionValue
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Transaction Value"),
                ]),
                _vm._v(" "),
                _c(
                  "strong",
                  [
                    _c("SvgIcon", { attrs: { icon: "value" } }),
                    _vm.resource.transactionCurrency
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.resource.transactionCurrency)),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.resource.transactionValue) + "m"),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.primarySector
            ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Main Sector")]),
                _vm._v(" "),
                _c("span", { staticClass: "sector" }, [
                  _vm._v(_vm._s(_vm.resource.primarySector.name)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.sectors
            ? _c(
                "li",
                { staticClass: "col-12 col-md-6 detail" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("Sectors")]),
                  _vm._v(" "),
                  _vm._l(_vm.resource.sectors, function (sector) {
                    return _c("span", { staticClass: "sector" }, [
                      _vm._v(_vm._s(sector.name)),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("Accordion", {
        attrs: { items: _vm.formatAccordionData(), "start-open": true },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "grid" }, [
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _vm.resource.differenceMade
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v("Value added to the project"),
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.resource.differenceMade) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.testimonial
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "header" }, [_vm._v("Testimonial")]),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.resource.testimonial) },
                }),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-4" },
          [
            _vm.resource.member
              ? _c("MemberCard", { attrs: { member: _vm.resource.member } })
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.lead
              ? _c(
                  "div",
                  { staticClass: "profile-list" },
                  [
                    _c("p", { staticClass: "profile-list__title" }, [
                      _vm._v("Lead User"),
                    ]),
                    _vm._v(" "),
                    _c("UserCard", {
                      attrs: { user: _vm.resource.lead, borderless: true },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filterLead(_vm.resource.team).length
              ? _c(
                  "div",
                  { staticClass: "profile-list" },
                  [
                    _c("p", { staticClass: "profile-list__title" }, [
                      _vm._v("Users also involved"),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.filterLead(_vm.resource.team),
                      function (profile) {
                        return _c("UserCard", {
                          key: profile.id,
                          attrs: {
                            user: profile,
                            borderless: true,
                            small: true,
                          },
                        })
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }